import { useContext, useMemo } from "react";
// contexts
import { CartContext } from "@cart-client/contexts/CartContext";
// utils
import { getDeliverySpeedPresentationInfo } from "@cart-client/helpers/CartDeliverySpeed";
import { isEmpty } from "@swiggy-private/core-ui";

const customPaddingConfig = {
    paddingBottom: "0",
};

export const useComputeTabContainerPadding = () => {
    const {
        cartState: { reviewedCart: cartResponse },
    } = useContext(CartContext);

    const customPadding = useMemo(() => {
        // any option which has banner presentation enabled
        // we need to modify padding for tab container in case any of the option has banner presentation enabled
        const deliverySpeedPresentationInfo = getDeliverySpeedPresentationInfo(cartResponse?.data);
        const deliverySpeedWidgetInfo = deliverySpeedPresentationInfo?.delivery_speed_widget_info ?? null;
        const options = deliverySpeedWidgetInfo?.delivery_speed_options ?? [];

        const anyOptionHasBannerPresentation = options.some(
            option =>
                !isEmpty(option.delivery_speed_only_presentation) &&
                !isEmpty(option.delivery_speed_only_presentation_icon),
        );

        return anyOptionHasBannerPresentation ? customPaddingConfig : undefined;
    }, [cartResponse?.data]);

    return {
        customPadding,
    };
};
